import { LineItemDetailOption } from "@redotech/redo-return-core-common/exchange-settings";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import type {
  OperationsSettingsPatch,
  ReturnsOperationsSettingsSource,
  StoredMetafieldDisplay,
} from "./operations-settings-source";

const MetafieldDisplaySchema = z.object({
  key: z.string(),
  displayName: z.string().optional(),
});

/** What staff see on a return in the merchant app. */
export const returnPageDisplaySettingsShape = {
  returnPageDisplay: z.object({
    defaultCollapsed: z.boolean(),
    aiReviewDefaultCollapsed: z.boolean(),
    lineItemDetailOptions: z.array(createEnum(LineItemDetailOption)),
    productMetafieldDisplays: z.array(MetafieldDisplaySchema),
    variantMetafieldDisplays: z.array(MetafieldDisplaySchema),
  }),
};

export type ReturnPageDisplaySettings = z.infer<
  z.ZodObject<typeof returnPageDisplaySettingsShape>
>;

function metafieldDisplays(
  stored: StoredMetafieldDisplay[] | null | undefined,
): ReturnPageDisplaySettings["returnPageDisplay"]["productMetafieldDisplays"] {
  return (stored ?? []).map(({ key, displayName }) =>
    displayName ? { key, displayName } : { key },
  );
}

export function returnPageDisplaySettingsFromTeam({
  settings,
}: ReturnsOperationsSettingsSource): ReturnPageDisplaySettings {
  const ui = settings.returnsUI;
  return {
    returnPageDisplay: {
      defaultCollapsed: ui?.defaultCollapsed ?? false,
      aiReviewDefaultCollapsed: ui?.aiReviewDefaultCollapsed ?? false,
      lineItemDetailOptions: ui?.lineItemDetailOptions ?? [],
      productMetafieldDisplays: metafieldDisplays(ui?.productMetafieldDisplays),
      variantMetafieldDisplays: metafieldDisplays(ui?.variantMetafieldDisplays),
    },
  };
}

export function returnPageDisplayTeamPatch({
  returnPageDisplay,
}: ReturnPageDisplaySettings): OperationsSettingsPatch {
  return {
    set: {
      "returnsUI.defaultCollapsed": returnPageDisplay.defaultCollapsed,
      "returnsUI.aiReviewDefaultCollapsed":
        returnPageDisplay.aiReviewDefaultCollapsed,
      "returnsUI.lineItemDetailOptions":
        returnPageDisplay.lineItemDetailOptions,
      "returnsUI.productMetafieldDisplays":
        returnPageDisplay.productMetafieldDisplays,
      "returnsUI.variantMetafieldDisplays":
        returnPageDisplay.variantMetafieldDisplays,
    },
    unset: [],
  };
}
